<template>
  <div>
    <back-profile @click.native="navigateTo('app.profile.attentions')"
      >Volver a Atenciones</back-profile
    >

    <attentions-by-type-header
      :bordered-header="true"
      :total-pending="this.totalByType('PENDING')"
      :total-failed="this.totalByType('FAILED')"
      :total-completed="this.totalByType('COMPLETED')"
      style="padding-bottom: 25px; margin: 10px 0;"
    >
      <template slot="header">
        <div v-if="this.attentionsByType[0]">{{ attentionTitle(this.attentionsByType[0]) }}</div>
      </template>
    </attentions-by-type-header>

    <ul style="padding-inline-start: 0px;">
      <li v-for="studentAttention in this.attentionByState()" :key="studentAttention.id">
        <attentions-by-type-body
          :bordered-header="true"
          :attention="studentAttention"
          :user="user"
          style="margin: 10px 0;"
          @finish-attention="finishAttention"
          @delete-attention="deleteAttention"
        >
          <template slot="subheader">{{ attentionStatus(studentAttention) }}</template>

          <div class="meta-list">
            <hr />

            <div
              v-if="
                studentAttention.participationOf && studentAttention.participationOf.comment.comment
              "
              class="meta-item"
            >
              <span class="meta-name has-text-weight-bold">Resultado:</span>
              <span class="meta-value">{{ studentAttention.participationOf.comment.comment }}</span>
            </div>
            <div
              v-if="
                studentAttention.status !== 'FAILED' &&
                  studentAttention.participationOf &&
                  studentAttention.participationOf['evaluation']
              "
              class="meta-item"
            >
              <span class="meta-name has-text-weight-bold">Evaluación:</span>
              <span class="meta-value">
                <button class="emotion">
                  {{ evaluationIconScore[studentAttention.participationOf["evaluation"]] }}
                </button>
              </span>
            </div>
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Fecha de cierre:</span>
              <span class="meta-value">{{
                studentAttention.performedAt | formatStandardDate
              }}</span>
            </div>
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Responsable de cierre:</span>
              <span class="meta-value">{{ finishedByUser(studentAttention) }}</span>
            </div>
          </div>
          <div class="description">
            <i></i>
          </div>
        </attentions-by-type-body>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from "moment"
import ATTENTIONS_BY_TYPE from "./graphql/AttentionsByType.gql"

import Block from "@/components/_base/Block.vue"
import AttentionsByTypeHeader from "@/components/_base/AttentionsByTypeHeader.vue"
import AttentionsByTypeBody from "@/components/_base/AttentionsByTypeBody.vue"
import BackProfile from "@/components/_base/BackProfile.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileAttentionsByType",

  components: {
    Block,
    BackProfile,
    AttentionsByTypeHeader,
    AttentionsByTypeBody
  },

  props: {
    studentId: {
      type: String
    },
    attentionActionId: {
      type: String
    },
    user: {
      type: Object
    }
  },

  data() {
    return {
      attentionsByType: [],
      evaluationIconScore: { YAY: ":)", MEH: ":|", SAD: ":(" }
    }
  },

  apollo: {
    attentionsByType: {
      query: ATTENTIONS_BY_TYPE,
      variables() {
        return {
          tareaId: this.attentionActionId,
          studentId: this.studentId
        }
      }
    }
  },

  methods: {
    attentionByState() {
      let orderedAttentions = []

      for (let i = 0; i < this.attentionsByType.length; i++) {
        if (this.attentionsByType[i].status === "PENDING") {
          orderedAttentions.unshift(this.attentionsByType[i])
        } else {
          orderedAttentions.push(this.attentionsByType[i])
        }
      }

      return orderedAttentions
    },
    finishedByUser(studentAttention) {
      if (studentAttention.finishedBy) {
        return studentAttention.finishedBy.name
      } else {
        return "-"
      }
    },
    finishAttention(attentionId) {
      this.navigateTo({
        state: "app.profile.finish_attention",
        params: {
          attentionId
        }
      })
    },
    deleteAttention(attentionId) {
      this.navigateTo({
        state: "app.profile.delete_attention",
        params: {
          attentionId
        }
      })
    },
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    attentionTitle(item) {
      let title = item.action.plan.category.name
      if (!item.action.plan.hidden) title += " - " + item.action.plan.name
      if (!item.action.hidden) title += " - " + item.action.name
      return title
    },
    attentionStatus(attention) {
      let status
      if (attention.status == "PENDING") status = "pendiente"
      if (attention.status == "COMPLETED") status = "realizada"
      if (attention.status == "FAILED") status = "fallida"
      return status
    },
    totalByType(type) {
      let total = 0
      this.attentionsByType.map(a => {
        if (a.status === type) {
          total += 1
        }
      })
      return total
    }
  },

  filters: {
    humanizeDate(date) {
      if (date === null) {
        return "-"
      } else {
        const m = moment(date)
        return m.fromNow()
      }
    },
    formatStandardDate(date) {
      if (date === null) {
        return "-"
      } else {
        return moment(date).format("DD/MM/YYYY")
      }
    }
  }
}
</script>

<style scoped>
.meta-list {
  margin-bottom: 30px;
}

.meta-item {
  margin-bottom: 10px;
}

.description {
  margin-bottom: 20px;
}

.emotion {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  transform: rotate(90deg);
  font-size: 18px;
  line-height: 18px;
  width: 30px;
  height: 30px;
  pointer-events: none;
}

li {
  list-style-type: none;
}
</style>
